import _ from "lodash";

export const formatReceivedData = ({ data, nationalities }) => ({
  ...data,
  nationality_id:
    _.chain(nationalities)
      .filter((elm) => elm.id === data.nationality_id)
      .map((elm) => ({ label: elm.name, value: elm.id }))
      .value() || [],
});

export const formatSubCompanyModalData = ({ data, id }) => ({
  subcontractor_id: Number(id),
  subcontractor_company_id: data?.subcontractor_company_id,
  establishment_date_end: data?.establishment_date_end,
  establishment_date: data?.establishment_date,
  id: data.id,
});
